import type { ReactNode } from "react";

/**
 * O cabeçalho dos painéis da biblioteca: o que se está vendo e o "Fechar" sempre à vista.
 *
 * `Sobreposicao` só fecha pelo Esc e pelo toque no fundo, e no celular o fundo é uma faixa de poucos
 * pixels. Daí o botão, com 44 px de alvo.
 */
export function CabecalhoDoPainel({
  titulo,
  selos,
  aoFechar,
  fecharDesligado,
}: {
  titulo: string;
  /** As etiquetas acima do título: tipo, "Pública". */
  selos?: ReactNode;
  aoFechar: () => void;
  /** Durante o envio: fechar não cancelaria nada, só esconderia o andamento. */
  fecharDesligado?: boolean;
}) {
  return (
    <header className="flex items-start justify-between gap-3 border-b border-borda px-4 py-3 sm:px-6">
      <div className="min-w-0 py-1">
        {selos && <div className="mb-1.5 flex flex-wrap gap-1.5">{selos}</div>}
        <h2 className="font-display text-[1.25rem] leading-tight tracking-[-0.01em] wrap-anywhere">
          {titulo}
        </h2>
      </div>
      <button
        type="button"
        onClick={aoFechar}
        disabled={fecharDesligado}
        className="-mr-2 inline-flex min-h-11 shrink-0 items-center rounded-peca px-3 text-[0.9375rem] text-texto-suave transition-colors hover:bg-superficie hover:text-texto disabled:cursor-not-allowed disabled:opacity-50"
      >
        Fechar
      </button>
    </header>
  );
}
